import React, { useCallback } from 'react'

import { pluralize } from 'humanize-plus'
import spacetime from 'spacetime'

import { ButtonGroup, Checkbox, IconButton, Table } from '@driftt/dds'
import { faPenToSquare } from '@driftt/dds.icons/regular/faPenToSquare'

import { GuestNotification, GuestNotificationTypeEnum } from 'types/MeetingType'

interface GuestEmailSettingsProps {
  guestNotifications: Record<GuestNotificationTypeEnum, GuestNotification>
  toggleEmailTemplate: (type: GuestNotificationTypeEnum) => void
  disabled: boolean
  setModalEditMode: (modalEditMode: GuestNotificationTypeEnum) => void
}

export const FollowUpEmailTable = ({
  guestNotifications,
  toggleEmailTemplate,
  disabled,
  setModalEditMode,
}: GuestEmailSettingsProps) => {
  const getHumanizedTime = useCallback((time: number) => {
    const s = spacetime()
    const timeDiff = s.subtract(time, 'milliseconds').diff(s)

    if (timeDiff.days > 0) {
      return `${timeDiff.days} ${pluralize(
        timeDiff.days,
        'day',
        'days'
      )} before`
    } else if (timeDiff.hours > 0) {
      return `${timeDiff.hours} ${pluralize(
        timeDiff.hours,
        'hour',
        'hours'
      )} before`
    } else if (timeDiff.minutes > 0) {
      return `${timeDiff.minutes} ${pluralize(
        timeDiff.minutes,
        'minute',
        'minutes'
      )} before`
    }
    return 'at the start of the meeting'
  }, [])

  return (
    <>
      <Table
        rows={[
          {
            ...guestNotifications.MEETING_REMINDER,
            type: GuestNotificationTypeEnum.MEETING_REMINDER,
          },
          {
            ...guestNotifications.MEETING_REMINDER_FOLLOW,
            type: GuestNotificationTypeEnum.MEETING_REMINDER_FOLLOW,
          },
        ]}
        columns={[
          {
            id: 'checkboxes',
            render: ({ type, on }) =>
              !disabled && (
                <Checkbox
                  ariaLabel={`Enable ${type}`}
                  checked={on}
                  onChange={() => {
                    toggleEmailTemplate(type)
                  }}
                />
              ),
          },
          {
            value: 'emailSubject',
            header: 'Email subject',
            cell: ({ emailSubject }) => (
              <div
                dangerouslySetInnerHTML={{
                  __html: emailSubject,
                }}
              />
            ),
            disableSort: true,
          },
          {
            value: 'delayTime',
            header: 'Timing',
            cell: ({ delayTime }) => getHumanizedTime(delayTime),
            size: 150,
            disableSort: true,
          },
          {
            id: 'actions',
            render: ({ type }) =>
              !disabled && (
                <ButtonGroup>
                  <IconButton
                    icon={faPenToSquare}
                    title="Edit"
                    onClick={() => {
                      setModalEditMode(type)
                    }}
                  />
                </ButtonGroup>
              ),
            size: 100,
            disableSort: true,
          },
        ]}
      />
    </>
  )
}
